import React from 'react';
import { AnimatedLoader } from './AnimatedLoader';

interface FullScreenLoaderProps {
  message?: string;
  showOverlay?: boolean;
}

/**
 * Full-screen loading component with animated loader and optional message
 * Provides a consistent loading experience across the application
 */
export const FullScreenLoader = ({
  message = 'Loading...',
  showOverlay = true,
}: FullScreenLoaderProps) => {
  const overlayClasses = showOverlay
    ? 'fixed inset-0 bg-gray-900 bg-opacity-100 z-50'
    : 'min-h-screen bg-gray-900';

  return (
    <div className={`${overlayClasses} flex flex-col items-center justify-center`}>
      <AnimatedLoader size={120} />
      {message && (
        <p className="text-white text-center text-lg mt-8 max-w-md px-4 animate-pulse">{message}</p>
      )}
    </div>
  );
};
